import { ref } from 'vue'

interface SnackbarAction {
  label: string
  to?: string
  onClick?: () => void
}

interface SnackbarState {
  show: boolean
  message: string
  color: string
  timeout: number
  action: SnackbarAction | null
}

const snackbar = ref<SnackbarState>({
  show: false,
  message: '',
  color: 'info',
  timeout: 4000,
  action: null,
})

let hideTimer: ReturnType<typeof setTimeout> | null = null

export const useSnackbar = () => {
  const showSnackbar = (
    message: string,
    color = 'info',
    timeout = 4000,
    action: SnackbarAction | null = null,
  ) => {
    snackbar.value = {
      show: true,
      message,
      color,
      timeout,
      action,
    }

    // UiSnackbar сам не скрывается - таймер живёт здесь. timeout <= 0 - не скрывать
    if (hideTimer) clearTimeout(hideTimer)
    if (timeout > 0) {
      hideTimer = setTimeout(() => {
        snackbar.value.show = false
        snackbar.value.action = null
      }, timeout)
    }
  }

  const showSuccess = (message: string, timeout = 4000, action: SnackbarAction | null = null) => {
    showSnackbar(message, 'success', timeout, action)
  }

  const showError = (message: string, timeout = 6000, action: SnackbarAction | null = null) => {
    showSnackbar(message, 'error', timeout, action)
  }

  const showWarning = (message: string, timeout = 5000, action: SnackbarAction | null = null) => {
    showSnackbar(message, 'warning', timeout, action)
  }

  const showInfo = (message: string, timeout = 4000, action: SnackbarAction | null = null) => {
    showSnackbar(message, 'info', timeout, action)
  }

  const hideSnackbar = () => {
    if (hideTimer) clearTimeout(hideTimer)
    snackbar.value.show = false
    snackbar.value.action = null
  }

  return {
    snackbar,
    showSnackbar,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    hideSnackbar,
  }
}
